<template>
    <div>
        <button class="more-info-indicator kbd invisible" @mousedown.stop="showAccountEditor">
            <i class="i-ph-pencil hover:bg-primary" />
        </button>
        <teleport to=".account-picker-container">
            <component
                :is="dynamicPopup"
                v-if="dynamicPopup"
                v-bind="dynamicProps"
                v-on="dynamicHandlers"
                @close="clearDynamicPopup"
            />
        </teleport>
    </div>
</template>

<script setup lang="ts">

import EditSubAccountPopup from '@/subaccount/EditSubAccountPopup.vue'
import {computed, ref} from 'vue'
import {CUSTOMER, SubAccount} from '@/subaccount/types/SubAccount'
import {CUSTOMER_ACCOUNT_NO, SUPPLIER_ACCOUNT_NO} from '@/bookkeeping-account/accountTypes'
import {bookkeepingAccounts} from '@/bookkeeping-account/bookkeepingAccount.service'
import {useSubAccounts} from '@/subaccount/subAccount.service'
import {BookkeepingAccount} from '@/bookkeeping-account/BookkeepingAccount'
import EditBookkeepingAccountPopup from '@/bookkeeping-account/EditBookkeepingAccountPopup.vue'
const {suppliers, customers} = useSubAccounts()
const emit = defineEmits(['updated'])
const dynamicPopup = ref()
const dynamicProps = ref()
const dynamicHandlers = ref({})

const props = defineProps({
    item: {
        type: Object as () => { accountNo: string, displayName: string, subKey: string | null },
        required: true
    }
})

const clearDynamicPopup = () => {
    dynamicPopup.value = null
    dynamicProps.value = null
    dynamicHandlers.value = {}
}

const account = computed(() => {
    if (props.item?.subKey) {
        if (props.item.accountNo === CUSTOMER_ACCOUNT_NO)
        {
            const customer = customers.value.find(c => c.subAccountNo === Number(props.item?.subKey))
            if (customer) return customer
        }
        const supplier = suppliers.value.find(s => s.subAccountNo === Number(props.item?.subKey))
        if (supplier) return supplier
    } else {
        return bookkeepingAccounts.value.find(acc => acc.accountNo === props.item.accountNo)
    }
    return undefined
})

const showEditSubAccountPopup = () => {
    dynamicPopup.value = EditSubAccountPopup
    dynamicProps.value = {
        subAccount: account.value
    }
    dynamicHandlers.value = {
        updated: (sacc: SubAccount) => {
            const saccMasterAcc = sacc.relationType === CUSTOMER ? CUSTOMER_ACCOUNT_NO : SUPPLIER_ACCOUNT_NO
            emit('updated', saccMasterAcc + ':' + sacc.subAccountNo)
        }
    }
}

const showEditBookkeepingAccountPopup = () => {
    dynamicPopup.value = EditBookkeepingAccountPopup
    dynamicProps.value = {
        account: account.value
    }
    dynamicHandlers.value = {
        updated: (acc: BookkeepingAccount) => {
            emit('updated', acc.accountNo)
            clearDynamicPopup()
        }
    }
}

const showAccountEditor = () => {
    if (props.item?.subKey){
        showEditSubAccountPopup()
    } else {
        showEditBookkeepingAccountPopup()
    }
}
</script>

<style scoped>

</style>